import type { PermissionKey } from "@procuremate/shared";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "@/features/auth/api";

/** True if the signed-in user holds the permission. UI hint only — the API enforces access. */
export function useHasPermission(permission: PermissionKey): boolean {
  const me = useCurrentUser();
  return me.data?.permissions.includes(permission) ?? false;
}

/** Renders children only for users with the permission; others get a plain explanation. */
export function RequirePermission({ permission, children }: { permission: PermissionKey; children: ReactNode }) {
  const { t } = useTranslation();
  if (!useHasPermission(permission)) {
    return (
      <section className="rounded-lg bg-surface p-8 shadow-card">
        <h1 className="text-2xl font-bold text-primary">{t("app.forbiddenTitle")}</h1>
        <p className="mt-2 text-fg-muted">{t("app.forbiddenBody")}</p>
      </section>
    );
  }
  return <>{children}</>;
}
